import {  Injectable } from '@angular/core';
import { BehaviorSubject, Subject, distinctUntilChanged } from 'rxjs';
import { operationinterface } from 'src/app/interface/OperationInterface';
import { valorlatenteinterface } from 'src/app/interface/ValorLatenteInterface';
import { rendimientoanualinterface } from 'src/app/interface/RendimientoAnualInterface';
import { tablainterface } from 'src/app/interface/TablaInterface';
import { valorliquidativointerface } from '../interface/ValorLiquidativoInterface';
import { OptimalWallet } from '../interface/OptimalWallet';
import { MetaApiService } from './meta-api.service';

export interface Broker{

    PoderAdquisitivo:number,
    ValorLiquidativo: number,
    MargenTotal: number,
    FondosDisponible: number,
    Efectivo: number
}


@Injectable({
    providedIn: 'root',
})

export class BrokerService {

    constructor(private metaApiService: MetaApiService) { }

    private idnectumsArraySubject = new BehaviorSubject<number[]>([]); // Array global para almacenar idnectums
    public idnectumsArray$ = this.idnectumsArraySubject.asObservable();
    
    private stkcfdSubject = new BehaviorSubject<string>('');
    stkcfd$ = this.stkcfdSubject.asObservable();
  
   
    updategestorIdnectumsArray(gestorIdnectumsArray: any) {
        console.log('Actualizando idnectumsArray en BrokerService:', gestorIdnectumsArray);
        this.idnectumsArraySubject.next(gestorIdnectumsArray);
    }
    updateStkcfd(value: string) {
        this.stkcfdSubject.next(value);
      }
    iniciadoTiempoReal: boolean = false;
    revisadosuscrito: boolean = false;
    
    private existeMargenSubject = new BehaviorSubject<boolean>(true);
    private existeMargenBrokerSubject = new BehaviorSubject<boolean>(true);
    private existeRiesgoSubject = new BehaviorSubject<boolean>(true);

    existeMargen$ = this.existeMargenSubject.asObservable();
    existeMargenBroker$ = this.existeMargenBrokerSubject.asObservable();
    existeRiesgo$ = this.existeRiesgoSubject.asObservable();
    /* Behavior Subject */
    private brokOperaciones = new BehaviorSubject<operationinterface[]>([]);
    private brokValLatente = new BehaviorSubject<valorlatenteinterface[]>([]);
    private brokValLiq = new BehaviorSubject<valorliquidativointerface[]>([]);
    private brokValPos = new BehaviorSubject<operationinterface[]>([]);
    private brokValVentas = new BehaviorSubject<operationinterface[]>([]);
    private brokRentabilidad = new BehaviorSubject<tablainterface[]>([]);
    private brokRendAnual = new BehaviorSubject<rendimientoanualinterface[]>([]);
    private brokRiesgo = new BehaviorSubject<tablainterface[]>([]);
    private brokidcarteras = new BehaviorSubject<number>(0);
    private brokFechaFiltro = new BehaviorSubject<string>('');
    public idMercado = new BehaviorSubject<any>('');
    private brokOptimaWallet = new BehaviorSubject<OptimalWallet[]>([]);
    private BrokcompaniaMercado = new BehaviorSubject<any>([]);
    private actualizarCartera = new BehaviorSubject<boolean>(false);
    private companiaSeleccionada = new BehaviorSubject<any>([]);
    private cargarListas = new BehaviorSubject<boolean>(false);
    isProc = new BehaviorSubject<boolean>(false);
    isACtual = new BehaviorSubject<boolean>(false);
    executeGrap = new BehaviorSubject<boolean>(false);
    //iniciadoTiempoReal$ = this.inicia.asObservable();

    /* Observables */
    valBrokOp$ = this.brokOperaciones.asObservable();
    valBrokLatente$ = this.brokValLatente.asObservable();
    valBrokValLiq$ = this.brokValLiq.asObservable();
    valBrokValPos$ = this.brokValPos.asObservable();
    valBrokVentas$ = this.brokValVentas.asObservable();
    valBrokRentabilidad$= this.brokRentabilidad.asObservable();
    valBrokRendAnual$ = this.brokRendAnual.asObservable();
    valBrokRiesgo$ = this.brokRiesgo.asObservable();
    valBrokIdeCarteras$ = this.brokidcarteras.asObservable();
    valBrokFechaFiltro$ = this.brokFechaFiltro.asObservable();
    valBrokOptimaWallet$ =this.brokOptimaWallet.asObservable();
    valBrokCompania$ = this.BrokcompaniaMercado.asObservable();
    valCompaniaSelec$ = this.companiaSeleccionada.asObservable();
    valcargarListas$ = this.cargarListas.asObservable();
    valBrokExecuteGrap$ = this.executeGrap.asObservable();
    valBrokidMercado$ = this.idMercado.asObservable();


    valactualizarCartera$ = this.actualizarCartera.asObservable().pipe(
        distinctUntilChanged()
    );
    valIsProc$= this.isProc.asObservable();
    valisACtual$ = this.isACtual.asObservable();

    public defaultOptima : OptimalWallet={
        apalancamiento: 4,
        bajista: false,
        capitalinicial: 0.0,
        idcartera: 0,
        nombre: '',
        valorLiquidativo: 0.0,
        valorliquidativoTemp: 0.0,
        riesgomaximo: 50.0,
        tipocuenta: 'MARGEN',
        tiporiesgo: 'LIMITADO',
        riesgo: 0,
        comisionbroker: 0,
        idmercado: 0,
        intervalotiempo: 0,
        prima: false,
        participacion: false,
        simulado: true,
        poderCompra: 0.0,
        numeroReconfiguracion: 0,
        stopLoss: 0,
        profit: 0,
        capitales: [0.0, 0.0],
        fondosDisponibles: 0,
        margen: 0,
        margenRequeridoPor: 0,
        controlMarginCall: 0,
        lista: 0,
        nOperaciones: 0,
        maxDiferenciaCierres: 0.0,
        rendimientoNeto: 0.0,
        rendimientomedioanual: 0.0,
        rendimientoacumuladoanual: 0.0,
        tasacrecimientoanualcompuesto: 0.0,
        periodosoperativa: 0,
        beneficioneto: 0.0,
        beneficionetoporcentual: 0.0,
        mayorretrocesodesdemaximo: 0.0,
        mayorretrocesodesdemaximoporcentual: 0.0,
        mediabeneficioperdidaporcentual: 0.0,
        sumaresiduosbeneficioperdidaporcentual: 0.0,
        volatilidadperiodo: 0.0,
        volatilidadanual: 0.0,
        mesesdd: 0,
        maximoretrocesoperiodo: 0.0,
        sumarrendimientosanuales: 0.0,
        prombeneficiointervalo: 0.0,
        prombeneficionintervaloporcentual: 0.0,
        sumatorio: false,
        coeficientevolatilidadanual: 1.0,
        ratiobeneficioriesgo: 0.0,
        modelodesde: '',
        efectivo: 0.0,
        gastosGestionPor: 1.0,
        gastosPrestamoPor: 8.0,
        nRecalcular: 0,
        idModelo: 0,
        liquidativos: null,
        sincro: true,auto:false,
        idCarteras: [0, 0, 0, 0, 0],
        subCarteras:'',
        chkgastogest:true,
        chkgastoprest:true,
        chkcomisionbroker:true
    };
//  auto: boolean=false;

    updateBrokExecuteGrap(data: boolean){
        this.executeGrap.next(data);
    }

    getOptimaWallet(){
        return this.brokOptimaWallet.value;
    }

    updatebrokidMercado(data: any){
        this.idMercado.next(data);
    }

    updateIsProc(value: boolean): void {
        this.isProc.next(value);
    }

    updateIsACtual(value: boolean): void {
        this.isACtual.next(value);
    }

    updateBrokOpe(newOpe: any){
        this.brokOperaciones.next(newOpe);
    }

    updateCompaniaSelec (data: any){
        this.companiaSeleccionada.next(data);
    }
    updateactualizarCarteraBroker(data: boolean) {
        if (this.actualizarCartera.getValue() !== data) {
            this.actualizarCartera.next(data); // línea 66
        }
    }
    updatecargarListas(data: boolean) {
        if (this.cargarListas.getValue() !== data) {
            this.cargarListas.next(data); // línea 66
        }
    }

    updateBrokValLatente(data: any){
        this.brokValLatente.next(data);
    }

    updateBrokcompaniaMercado(data: any){
        this.BrokcompaniaMercado.next(data);
    }

    updateBrokValLiq(data: any){
        this.brokValLiq.next(data);
    }
    updateBrokValPos(data: any){
        this.brokValPos.next(data);
    }
    updateBrokValVentas(data: any){
        this.brokValVentas.next(data);
    }
    updateBrokRentabilidad(data: any){
        this.brokRentabilidad.next(data);
    }
    updateBrokRendAnual(data: any){
        this.brokRendAnual.next(data);
    }
    updateBrokRiesgo(data: any){
        this.brokRiesgo.next(data);
    }
    updateBrokidcarteras (data: any){
        this.brokidcarteras.next(data);
    }
    updateBrokFechaFiltro(data: any){
        this.brokFechaFiltro.next(data);
    }
    updateBrokOptimaWallet(data: any){
        this.brokOptimaWallet.next(data);
        const tipoBroker = data?.tipoBroker || '';
        localStorage.setItem('brokerTipoBroker', tipoBroker);
        // Dispatch a storage event so the same window's listeners also react
        // (native storage events only fire in OTHER windows)
        window.dispatchEvent(new StorageEvent('storage', { key: 'brokerTipoBroker', newValue: tipoBroker }));
    }
    getDefaultWallet(){
        return this.defaultOptima;
    }

    /**
     * Cierra la sesión de MetaAPI en este navegador: borra las credenciales y deja el estado del
     * bróker como desconectado. NO apaga el servidor de la cuenta (metaapi/undeploy), así que volver
     * a conectar es inmediato.
     *
     * El evento de storage se lanza a mano porque el nativo solo llega a las OTRAS pestañas.
     */
    cerrarSesionMetaApiLocal(){
        this.metaApiService.clearCredentials();
        localStorage.setItem('brokerConectado', 'false');
        window.dispatchEvent(new StorageEvent('storage', { key: 'brokerConectado', newValue: 'false' }));
        this.updateBrokOptimaWallet(this.getDefaultWallet());
        this.updateBrokcompaniaMercado([]);
    }

    updateExisteMargen(value: boolean) {
        this.existeMargenSubject.next(value);
    }

    updateExisteMargenBroker(value: boolean) {
        this.existeMargenBrokerSubject.next(value);
    }

    updateExisteRiesgo(value: boolean) {
        this.existeRiesgoSubject.next(value);
    }

}